import React, { createContext, useContext, useEffect, useState } from "react";
import { wsRequest, onBroadcast } from "./wsClient.js";

const CurrencyContext = createContext("£");

export function useCurrencySymbol() {
  return useContext(CurrencyContext);
}

// Wraps a whole page once; every component underneath can call
// useCurrencySymbol() instead of each fetching site settings independently
// or having the symbol threaded down through props.
export function CurrencyProvider({ children }) {
  const [symbol, setSymbol] = useState("£");

  const load = () => {
    wsRequest("siteSettings.get")
      .then((data) => {
        if (data?.currencySymbol) setSymbol(data.currencySymbol);
      })
      .catch(() => {});
  };

  useEffect(load, []);

  // Live-updates if root changes the currency while this page is open —
  // without this, it would only ever catch up on a full page reload.
  useEffect(() => {
    return onBroadcast((message) => {
      if (message.type === "site-settings-changed") load();
    });
  }, []);

  return <CurrencyContext.Provider value={symbol}>{children}</CurrencyContext.Provider>;
}
